// extracted by mini-css-extract-plugin
export default {"emptyState":"style_emptyState__vahi+","illustration":"style_illustration__QglbR","copy":"style_copy__IClZv","title":"style_title__Scc+F","description":"style_description__mqr1O"};